import { Board } from '../board';
import { BoardSnapshot } from '../board-snapshot';
import { AutoFinishMoveCommand } from '../commands/auto-finish-move-command';
import { GameLogicDepth } from '../game-logic-depth';
import { CardDisclosureStatus } from '../logic-types';
import { Action, GrantPointsAction } from './action';

export class AutoFinishAction implements Action {
  private move: AutoFinishMoveCommand;
  private board: Board;
  private gameLogicDepth: GameLogicDepth;
  private grantPointsAction: GrantPointsAction;
  private lastSnapshot: BoardSnapshot | undefined;
  private lastCardIndex: number | undefined;

  constructor(
    move: AutoFinishMoveCommand,
    board: Board,
    gameLogicDepth: GameLogicDepth,
    grantPointsAction: GrantPointsAction,
  ) {
    this.move = move;
    this.board = board;
    this.gameLogicDepth = gameLogicDepth;
    this.grantPointsAction = grantPointsAction;
  }

  public saveSnapshot(): void {
    this.lastSnapshot = this.board.boardSnapshot;
    this.board.boardSnapshot = new BoardSnapshot(
      this.lastSnapshot.foundations,
      this.lastSnapshot.tableaus,
      this.lastSnapshot.deck,
      this.lastSnapshot.waste,
    );
  }

  public execute(): void {
    this.saveSnapshot();

    const card = this.board.getCardByCardId(this.move.cardId);
    if (card === undefined) {
      return;
    }

    const originPile = this.board.getPileByCardId(this.move.cardId);
    if (originPile === undefined) {
      return;
    }

    const targetPile = this.board.getPileByPileId(this.move.targetPileId);

    card.openCard();
    card.setStatusWhenNone(CardDisclosureStatus.Pending);

    this.grantPointsAction({
      card: card,
      pile: targetPile,
    });

    originPile.removeCard(card);

    this.lastCardIndex = card.index;
    this.gameLogicDepth.updateCardDepth(card.index);

    targetPile.addCard(card);
  }

  public undo(): void {
    if (this.lastCardIndex !== undefined) {
      this.gameLogicDepth.updateCardDepth(this.lastCardIndex);
    }
    if (this.lastSnapshot !== undefined) {
      this.board.boardSnapshot = this.lastSnapshot;
    }
  }
}
